import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

export const ReportContext = createContext();

export const ReportProvider = ({ children }) => {
  const [settingsData, setSettingsData] = useState();
  const [tabValue, setTabValue] = useState(0); // active tab
  const [showCapacitySettings, setShowCapacitySettings] = useState(false);
  const [capacityNonce, setCapacityNonce] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // read reportSettingsData from local storage
    const reportSettingsData = localStorage.getItem("reportSettingsData");
    if (reportSettingsData) {
      setSettingsData(JSON.parse(reportSettingsData));
    } else {
      doSetSettingsData(reportContext_defaultSettingsData);
    }
    setIsLoaded(true);
  }, []);

  const doSetSettingsData = (settingsData) => {
    if (settingsData === null) settingsData = reportContext_defaultSettingsData;
    setSettingsData(settingsData);
    localStorage.setItem("reportSettingsData", JSON.stringify(settingsData));
  };

  return (
    <ReportContext.Provider
      value={{
        settingsData,
        setSettingsData: doSetSettingsData,
        tabValue,
        setTabValue,
        showCapacitySettings,
        setShowCapacitySettings,
        capacityNonce,
        setCapacityNonce,
        isLoaded,
      }}>
      {children}
    </ReportContext.Provider>
  );
};

export const useReportData = () => useContext(ReportContext);

ReportProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const reportContext_defaultSettingsData = {
  titleFontSize: 18,
  bodyFontSize: 15,
  driverSpacing: 1,
  rowSpacing: 2,
  showComments: true,
  showSource: false,

  capacity: {
    startH: 7,
    endH: 17,
    showAvailable: true,
    showReserved: true,
    minFreeMinutes: 120,
  },
};
